import { api } from './http';

export type LegalPage = {
  slug: string;
  title: string;
  body: string;
  seo_title: string;
  seo_description: string;
  state: 'published' | 'draft';
  sort: number;
  updated_at: string;
};

export type LegalResponse = {
  pages: LegalPage[];
  /** The {tokens} a body may use, filled from Settings when the page renders. */
  tokens: { token: string; note: string }[];
  routes: Record<string, string>;
};

export const legal = {
  load: (signal?: AbortSignal) => api.get<LegalResponse>('/legal', signal),
  save: (slug: string, body: Partial<LegalPage>) => api.put<{ page: LegalPage }>(`/legal/${slug}`, body),
  restore: (slug: string) => api.post<{ page: LegalPage }>(`/legal/${slug}/restore`, {}),
};
